<div class="group-filter-container">
  <div class="custom-group-dropdown">
    @if(CustomGroups.length == 0){
    <h3>No Group Filters Available Create One Here:</h3>
    }
    @else{
    <rms-select [options]="CustomGroups" label="Group Filters" labelKey="CustomGroupFilterName" valueKey="CustomGroupFilterID" [(ngModel)]="selectedGroupFilterID" (ngModelChange)="onLoadGroup($event)"></rms-select>
    }
    <button mat-button class="btn-bg-green" (click)="onCreateGroupFilter()">Create Group Filter</button>
  </div>

  @if(selectedGroupFilter){
  <fieldset class="rms-fieldset">
    <legend>{{selectedGroupFilter.CustomGroupFilterID ? selectedGroupFilter.CustomGroupFilterName : 'New Group'}}</legend>
    <div class="rms-fieldset-options">
      @if(selectedGroupFilter.CustomGroupFilterID){<button mat-icon-button (click)="editGroups = !editGroups" [ngStyle]="{color: editGroups ? 'red' : 'green'}"><mat-icon>{{editGroups ? 'close' : 'edit'}}</mat-icon></button>}
    </div>
    <form #GroupFilterForm="ngForm" style="display:flex; flex-direction: column; gap:10px">
      <div class="name-and-primary">
        @if(!selectedGroupFilter.CustomGroupFilterID || editGroups){
        <rms-input label="Group Filter Name" [(ngModel)]="selectedGroupFilter.CustomGroupFilterName" name="GFName" [required]="true"></rms-input>
        }
        <rms-checkbox label="Primary" [(ngModel)]="selectedGroupFilter.PrimaryFilter" name="primary"></rms-checkbox>
      </div>
      <div class="group-list">
        @for(groupData of SelectedGroupData; let i = $index; track $index){
        <rms-mod height="auto">
          <div class="group-filters">
            <rms-select [disabled]="!editGroups" [name]="'regionName' + i" [options]="Regions" label="Region" labelKey="RegionName" valueKey="RegionId" [(ngModel)]="groupData.RegionID" (ngModelChange)="onChangeRegion(i)"></rms-select>
            <rms-select [name]="'countryName' + i" [options]="groupData.filteredCountries" label="Country" labelKey="CountryName" valueKey="CountryID" [(ngModel)]="groupData.CountryID" (ngModelChange)="onChangeCountry(i)" [disabled]="!groupData.RegionID || !editGroups"></rms-select>
            <rms-select [name]="'groupName' + i" [options]="groupData.filteredGroups" label="Groups" labelKey="GroupName" valueKey="GroupID" [(ngModel)]="groupData.GroupID" [disabled]="!groupData.CountryID || !editGroups" [required]="true"></rms-select>
            @if(editGroups && SelectedGroupData.length > 1){<button mat-icon-button style="color: red" (click)="onDeleteGroup(i)"><mat-icon>delete</mat-icon></button>}
            @if(i == 0 && editGroups){<button mat-icon-button style="color: green" (click)="onAddGrouping()"><mat-icon>add</mat-icon></button>}
          </div>
        </rms-mod>
        }
      </div>
    </form>
  </fieldset>
  @if(editGroups){<button mat-button class="btn-bg-green" [disabled]="!GroupFilterForm.valid || saving" style="width:98%" (click)="onSaveGroupFilter()">{{selectedGroupFilter.CustomGroupFilterID ? 'Update' : 'Save'}} Group Filter</button>}
  }
</div>
